
import { computed, defineComponent, PropType, ref, toRefs, watch } from 'vue';
import { Vendor } from '@/types/app';
import AppTable from '@/components/tables/base/AppTable.vue';
import LocationCell from '@/components/tables/LocationCell.vue';
import Timestamp from '@/components/tables/TimestampCell.vue';
import { useTableSorting } from '@/utils';
import MaterialIcon from '@/components/MaterialIcon.vue';
import CheckboxInput from '../form-controls/base/CheckboxInput.vue';

export default defineComponent({
  name: 'VendorsTable',
  emits: ['update:vendor'],
  components: {
    AppTable,
    LocationCell,
    Timestamp,
    MaterialIcon,
    CheckboxInput
  },
  props: {
    vendors: {
      type: Array as PropType<Array<Vendor>>,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const { vendors } = toRefs(props);

    const normalizedVendors = computed(() =>
      vendors.value.map(vendor => ({
        ...vendor,
        enabled: vendor.enabled !== undefined && vendor.enabled !== null ? vendor.enabled : true
      }))
    );

    const localVendors = ref(normalizedVendors.value);

    // Watch for changes in the vendors prop and update localVendors
    watch(normalizedVendors, newVendors => {
      localVendors.value = newVendors;
    });

    const { sortedData: sortedVendors, sortBy, getSortState } = useTableSorting(localVendors, 'name');

    const updateVendor = (vendor: Vendor) => {
      const index = localVendors.value.findIndex(v => v.id === vendor.id);
      if (index !== -1) {
        localVendors.value[index] = { ...vendor };
        emit('update:vendor', vendor);
      }
    };

    return {
      sortedVendors,
      sortBy,
      getSortState,
      updateVendor
    };
  }
});
